
import Vue from 'vue';
import TextInput from '../Input/Input.vue';
import WebText from '../Text/Text.vue';
import { Row } from '../Grid';
import { Spacer } from '../Spacings';

/**
 * Input Field component.
 *
 * This input has the Label name and information / guide label.
 */
export default Vue.extend<any, any, any, any>({
  components: {
    TextInput,
    Row,
    Spacer,
    WebText
  },
  inheritAttrs: false,
  props: {
    /**
     * Variant for the Input.
     */
    variant: {
      type: String,
      default: 'base',
      required: true
    },
    /**
     * Label of the Input.
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Text variant of the Label.
     */
    labelVariant: {
      type: String,
      default: null
    },
    /**
     * Text ink of the Label.
     */
    labelInk: {
      type: String,
      default: null
    },
    /**
     * Error state of the Input.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * The information / guide in the left bottom of the Input.
     */
    leftInfo: {
      type: String,
      default: ''
    },
    /**
     * The information / guide in the right bottom of the Input.
     */
    rightInfo: {
      type: String,
      default: ''
    },
    /**
     * Value of the Input.
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Left icon of the Input.<br />
     * @type {VueComponent}
     */
    leftIcon: {
      default: null
    },
    /**
     * Search icon of the Input.<br />
     * @type {VueComponent}
     */
    searchIcon: {
      default: null
    },
    /**
     * Callback when user click search icon.
     */
    search: {
      type: Function,
      default: () => {}
    },
    /**
     * Make input has border.
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * Make placeholder of the left input.
     */
    additionField: {
      type: Boolean,
      default: false
    },
    /**
     * Text in left of the placeholder Input.
     */
    additionFieldValue: {
      type: String,
      default: ''
    },
    /**
     * Description of the Input.
     */
    desc: {
      type: String,
      default: ''
    },
    /**
     * Make input to paste-able value.
     */
    pasteInput: {
      type: Boolean,
      default: true
    },
    /**
     * Regex String for validation.<br />
     * If regex has backslash, please use `\\`
     */
    regexInput: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      focus: false
    };
  },
  computed: {
    isFocus() {
      return this.focus || !!this.value;
    },
    getPlaceholder() {
      if (this.variant === 'base') {
        // Return null if label is defined
        return this.$attrs.placeholder ? null : this.$attrs.placeholder;
      }
      return this.$attrs.placeholder;
    },
    getLabel() {
      const inputLabel = this.label || this.$attrs.placeholder;
      if (this.variant === 'base' && !this.leftIcon) {
        // Return null if label is defined
        return this.$attrs.placeholder ? inputLabel : this.$attrs.placeholder;
      }
      return this.label || this.$attrs.placeholder;
    }
  },
  methods: {
    handleChange(e: Event) {
      /**
       * Handle when the input value change.
       * @event input
       * @type {function}
       */
      this.$emit('input', (e.target as HTMLInputElement).value);
    },

    handleFocus() {
      this.focus = true;
    },

    handleBlur() {
      this.focus = false;
    }
  }
});
